<template>
    <v-col>
        <item-picker
            v-if="store.initialized"
            v-model="value"
            :store="store"
            item-title="name"
            item-value="id"
            :label="label ? label : 'Application'"
            :hint="hint"
            :prepend-icon="prependIcon"
        >
        </item-picker>
    </v-col>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import ItemPicker from "@/components/form_components/item_picker/ItemPicker.vue";
import {useApplicationStore} from "@/stores/ApplicationStore/ApplicationStore";
import {useVModel} from "@vueuse/core";

export default defineComponent({
    components: {
        ItemPicker
    },
    props: {
        modelValue: {
            type: Number
        },
        hint: {
            type: String
        },
        label: {
            type: String
        },
        prependIcon: {
            type: String
        }
    },
    setup(props, {emit}) {
        const value = useVModel(props, 'modelValue', emit);
        const store = useApplicationStore()

        return {
            value,
            store
        }
    }
})
</script>